import BossModel from "@/models/BossModel";

export default class ProductInternalTagType extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/internal-tag/type';

    /**
     *
     * @type {string}
     */
    static entity = 'productInternalTagTypes';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new ProductInternalTagType(data[key]));
            }
            return instances;
        });
    }

    /**
     * @param params
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api().limit(0).get(true);
    }
}
